import { render, staticRenderFns } from "./blindBoard.vue?vue&type=template&id=3138730f&scoped=true"
import script from "./blindBoard.vue?vue&type=script&lang=js"
export * from "./blindBoard.vue?vue&type=script&lang=js"
import style0 from "./commonTable.css?vue&type=style&index=0&id=3138730f&prod&scoped=true&lang=css&external"
import style1 from "./blindBoard.vue?vue&type=style&index=1&id=3138730f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3138730f",
  null
  
)

export default component.exports